/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPPRODUCT } from './IAPPRODUCT';
import {
    IAPPRODUCTFromJSON,
    IAPPRODUCTFromJSONTyped,
    IAPPRODUCTToJSON,
} from './IAPPRODUCT';

/**
 * 
 * @export
 * @interface PaymentDetailsUnitTransferInvestmentViewModel
 */
export interface PaymentDetailsUnitTransferInvestmentViewModel {
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsUnitTransferInvestmentViewModel
     */
    premiumId?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsUnitTransferInvestmentViewModel
     */
    premiumTransferAssetInvestmentId?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsUnitTransferInvestmentViewModel
     */
    providerId?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsUnitTransferInvestmentViewModel
     */
    assetCodeForCollectiveInvestment?: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentDetailsUnitTransferInvestmentViewModel
     */
    nameForCollectiveInvestment?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentDetailsUnitTransferInvestmentViewModel
     */
    investmentNumber?: string;
    /**
     * 
     * @type {IAPPRODUCT}
     * @memberof PaymentDetailsUnitTransferInvestmentViewModel
     */
    investmentNameId?: IAPPRODUCT;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsUnitTransferInvestmentViewModel
     */
    transferPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDetailsUnitTransferInvestmentViewModel
     */
    estimatedUnits?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentDetailsUnitTransferInvestmentViewModel
     */
    cancelDebitOrder: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentDetailsUnitTransferInvestmentViewModel
     */
    canDelete: boolean;
}

/**
 * Check if a given object implements the PaymentDetailsUnitTransferInvestmentViewModel interface.
 */
export function instanceOfPaymentDetailsUnitTransferInvestmentViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "cancelDebitOrder" in value;
    isInstance = isInstance && "canDelete" in value;

    return isInstance;
}

export function PaymentDetailsUnitTransferInvestmentViewModelFromJSON(json: any): PaymentDetailsUnitTransferInvestmentViewModel {
    return PaymentDetailsUnitTransferInvestmentViewModelFromJSONTyped(json, false);
}

export function PaymentDetailsUnitTransferInvestmentViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentDetailsUnitTransferInvestmentViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'premiumId': !exists(json, 'PremiumId') ? undefined : json['PremiumId'],
        'premiumTransferAssetInvestmentId': !exists(json, 'PremiumTransferAssetInvestmentId') ? undefined : json['PremiumTransferAssetInvestmentId'],
        'providerId': !exists(json, 'ProviderId') ? undefined : json['ProviderId'],
        'assetCodeForCollectiveInvestment': !exists(json, 'AssetCodeForCollectiveInvestment') ? undefined : json['AssetCodeForCollectiveInvestment'],
        'nameForCollectiveInvestment': !exists(json, 'NameForCollectiveInvestment') ? undefined : json['NameForCollectiveInvestment'],
        'investmentNumber': !exists(json, 'InvestmentNumber') ? undefined : json['InvestmentNumber'],
        'investmentNameId': !exists(json, 'InvestmentNameId') ? undefined : IAPPRODUCTFromJSON(json['InvestmentNameId']),
        'transferPercentage': !exists(json, 'TransferPercentage') ? undefined : json['TransferPercentage'],
        'estimatedUnits': !exists(json, 'EstimatedUnits') ? undefined : json['EstimatedUnits'],
        'cancelDebitOrder': json['CancelDebitOrder'],
        'canDelete': json['CanDelete'],
    };
}

export function PaymentDetailsUnitTransferInvestmentViewModelToJSON(value?: PaymentDetailsUnitTransferInvestmentViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PremiumId': value.premiumId,
        'PremiumTransferAssetInvestmentId': value.premiumTransferAssetInvestmentId,
        'ProviderId': value.providerId,
        'AssetCodeForCollectiveInvestment': value.assetCodeForCollectiveInvestment,
        'NameForCollectiveInvestment': value.nameForCollectiveInvestment,
        'InvestmentNumber': value.investmentNumber,
        'InvestmentNameId': IAPPRODUCTToJSON(value.investmentNameId),
        'TransferPercentage': value.transferPercentage,
        'EstimatedUnits': value.estimatedUnits,
        'CancelDebitOrder': value.cancelDebitOrder,
        'CanDelete': value.canDelete,
    };
}

